import { useMemo } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { AccessGate } from "./components/AccessGate";
import { SessionProvider, useSession, buildCase } from "./lib/session";
import { computeScores } from "./lib/scores";
import HistoryStep from "./components/steps/HistoryStep";
import FollowupStep from "./components/steps/FollowupStep";
import TriageStep from "./components/steps/TriageStep";
import ExamStep from "./components/steps/ExamStep";
import RefineStep from "./components/steps/RefineStep";
import InvestigationStep from "./components/steps/InvestigationStep";
import FinalStep from "./components/steps/FinalStep";
import ReportStep from "./components/steps/ReportStep";

function Wizard() {
  const { state, set, patch, run, pending } = useSession();
  const scores = useMemo(() => computeScores(state.vitals, state.labs, state.patient.age), [state.vitals, state.labs, state.patient.age]);

  const refine = () => {
    set("step", 4);
    run("refine", buildCase(state, scores, "refine"), (r) =>
      patch({ refined: r, selectedInv: (r.investigations || []).map((i) => i.name), extraAnswers: {}, final: null }));
  };

  const steps = [
    <HistoryStep />, <FollowupStep />, <TriageStep scores={scores} />, <ExamStep onRefine={refine} />,
    <RefineStep loading={!!pending.refine} onRefine={refine} />, <InvestigationStep />, <FinalStep scores={scores} />, <ReportStep scores={scores} />,
  ];
  return <main key={state.step} className="max-w-5xl mx-auto px-4 sm:px-6 py-10 pb-24">{steps[state.step]}</main>;
}

export default function App() {
  return (
    <>
      <AccessGate>
        <SessionProvider>
          <div className="min-h-screen bg-background cc-grain">
            <Header />
            <Wizard />
            <footer className="text-center text-xs text-muted-foreground pb-8 px-4">
              CritiCalc AI · Clinical decision support only - not a substitute for physician judgement · References: Vincent's Textbook of Critical Care, Washington Manual of Critical Care
            </footer>
          </div>
        </SessionProvider>
      </AccessGate>
      <Toaster position="top-right" />
    </>
  );
}
